import { render, staticRenderFns } from "./ProofWorkgeo.vue?vue&type=template&id=2bd7263a"
import script from "./ProofWorkgeo.vue?vue&type=script&lang=js"
export * from "./ProofWorkgeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports